module.exports = __webpack_public_path__ + "img/运动装备-3.622350c8.png";